export const pipe =
  (...fns) =>
  (x) => {
    return fns.reduce((v, f) => f(v), x);
  };
